import React from 'react';
import { SiteCard } from './SiteCard';
import { MOCK_SITES } from '../../utils/multiSiteData';
interface SiteStatusGridProps {
  onViewSite: (siteId: string) => void;
}
export function SiteStatusGrid({
  onViewSite
}: SiteStatusGridProps) {
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-6" data-id="element-244">
      {MOCK_SITES.map(site => <SiteCard key={site.id} site={site} onViewSite={onViewSite} data-id="element-245" />)}
    </div>;
}